interface VeeraLogoProps {
  size?: "sm" | "md" | "lg";
}

const sizeMap = {
  sm: { badge: "h-6 w-6 rounded-md text-xs", text: "text-sm", gap: "gap-1.5" },
  md: { badge: "h-8 w-8 rounded-lg text-sm", text: "text-lg", gap: "gap-2" },
  lg: { badge: "h-10 w-10 rounded-xl text-base", text: "text-2xl", gap: "gap-2.5" },
};

export function VeeraLogo({ size = "md" }: VeeraLogoProps) {
  const s = sizeMap[size];
  return (
    <div className={`flex items-center ${s.gap}`}>
      <div
        className={`${s.badge} flex items-center justify-center font-bold text-white`}
        style={{
          background: "linear-gradient(135deg, hsl(280, 80%, 65%), hsl(260, 70%, 50%))",
        }}
      >
        V
      </div>
      <span className={`${s.text} font-semibold text-foreground`}>Coach Veera</span>
    </div>
  );
}
